import { makePropCacheMixin } from '../utils/cache';
export default makePropCacheMixin('$listeners', 'bvListeners');


// WEBPACK FOOTER //
// ./node_modules/bootstrap-vue/esm/mixins/listeners.js